import React from "react";
import {ProductsMenu} from "./Products";
import {Modal} from "react-spaceship-web";
import {Link} from "react-router-dom";

export default class ProductChartOfAccount extends React.Component {
	constructor(props) {
		super(props);
		this.parent = null;
		this.state = {
			mode: this.props.mode,
			product: this.props.product,
			qs: window.Global.getAllQueryStrings()
		};

		// console.log(this.state, this.props);
	}

	// componentDidUpdate(prevProps, prevState) {
	// 	if (this.props.location.pathname !== prevProps.location.pathname) {
	// 		// this.route();
	// 	} else if (this.props.location.search !== prevProps.location.search) {
	// 		// this.route();
	// 		// this.setState({
	// 		// 	mode: 'list',
	// 		// 	is_loading: true,
	// 		// 	product: false,
	// 		// }, () => {
	// 		// 	this.fetch();
	// 		// })
	// 	}
	// }

	route() {
		window.Route.on({
			'/v2/products/:product_id/chart_of_account': (params) => {
				this.setState({
					mode: 'list',
					is_loading: true,
					params: params,
					product: false,
				}, () => {
					this.fetch();
				});
			},
		}).match();
	}

	fetch() {
		let data = window.Global.getAllQueryStrings();
		if (!data.status) {
			data.status = 'active';
		}
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product',
			data: {
				product_id: this.state.params.product_id,
				request_data_product_chart_of_account: 1,
			},
			done: (response) => {
				this.setState({
					product: response.product[0],
					is_loading: false,
				}, () => {

				});
			},
			fail: () => {

			}
		});
	}

	componentDidMount() {
		this.route();
	}

	manage() {
		console.log(this.parent);
		let $parent = window.$(window.Handlebars.compile(window.$('#template-product_bom_adjustment_cost').html())(this.props.product));
		let $form = $parent.find('.ui.form');
		$form.form2('init');

		$form.find('input[name="cost_product_id"]').explorer({
			url: window.GlobalFunc.getUrl('/api/product'),
			additionalData: {
				limit: 5,
				page: 1
			},
			key: 'product',
			template: {
				list: '<a class="item flex row">{{name}}</a>',
				selected: {
					text: 'name',
					value: 'id',
					placeholder: 'เลือกสินค้าต้นทุน'
				}
			},
			onSelected: function (product) {

			}
		});

		$form.find('input[name="cost_product_id"]')
			.explorer('set disable unselected');

		if (!this.props.product_chart_of_account) {
			// new
			$form.form2('submit', {
				method: 'POST',
				url: window.GlobalFunc.getUrl('/api/product/bom_adjustment_cost'),
				beforeSent: function (object) {
					object.product_id = this.props.product.id;
					return object;
				},
				submitButton: $parent.find('.button.approve'),
				loadingButton: $parent.find('.button.approve'),
				onSuccess: function (response) {
					window.Global.messageTop({
						type: 'positive',
						message: 'บันทึกข้อมูลเรียบร้อย'
					});
					// ProductBomAdjustmentCost.fetch(response.product);
					// $parent.modal('hide');
					window.location.reload();
				}
			});
		} else {
			// edit
			$form.form2('init', {
				data: this.props.product_chart_of_account
			});

			// $form.find('input[name="cost_product_id"]')
			// 	.explorer('set value', product_bom_adjustment_cost.cost_product)
			// 	.explorer('set disable unselected');

			$form.form2('submit', {
				method: 'PUT',
				url: window.GlobalFunc.getUrl('/api/product/bom_adjustment_cost'),
				beforeSent: function (object) {
					object.product_bom_adjustment_cost_id = this.props.product_chart_of_account.id;
					return object;
				},
				submitButton: $parent.find('.button.approve'),
				loadingButton: $parent.find('.button.approve'),
				onSuccess: function (response) {
					window.Global.messageTop({
						type: 'positive',
						message: 'บันทึกข้อมูลเรียบร้อย'
					});
					window.location.reload();
				}
			});

			$parent.find('.red.button').on('click', function () {
				window.Global.confirm({
					title: 'ยืนยันการลบ',
					content: 'โปรดยืนยันลบ การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้',
					cancel_text: 'ยกเลิก',
					approve_text: 'ลบ',
					onApprove: function ($modal) {
						var $button = $modal.find('.approve.button');
						$button.addClass('loading');
						window.Global.ajax({
							method: 'DELETE',
							url: window.GlobalFunc.getUrl('/api/product/bom_adjustment_cost'),
							data: {product_bom_adjustment_cost_id: this.props.product_chart_of_account.id},
							done: function (response) {
								$button.removeClass('loading');
								if (response.error && response['message']) {
									window.Global.messageTop({
										type: 'negative',
										message: response['message'][0]['error_message']
									});
									return;
								}
								if (!response.success) return;
								window.Global.messageTop({
									type: 'positive',
									message: 'ลบข้อมูลเรียบร้อย'
								});
								window.location.reload();
							}
						});
						return false;
					}
				});
			}).show();
		}

		$parent.modal({
			autofocus: false,
			onApprove: function () {
				return false;
			}
		}).modal('show');
	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<Link className={"section active"}
							      to={"/v2/products"}>สินค้า</Link>
							{
								this.state.product ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<Link className="section" to={"/v2/products/" + this.state.product.id}>
											{this.state.product.name} ({this.state.product.code})
										</Link>
									</>
									: null
							}
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<Link className="section active"
							      to={"/v2/products/" + this.state.product.id + '/chart_of_account'}>
								บันทึกบัญชี
							</Link>
						</div>
						<div className="right floated">
							<div className="ui positive button"
							     onClick={() => {
								     window.Global.reactToDom(
									     window.$('body'),
									     <ProductChartOfAccountManage
										     mode={'create'}
										     product={this.state.product}
										     product_chart_of_account={{
											     is_vat: 2
										     }}
										     onEditedSuccess={() => {

										     }}
									     />
								     );
							     }}>
								เพิ่มรายการ
							</div>
						</div>
					</div>
					<ProductsMenu product_id={this.state.product.id} index={4}/>
				</div>
				<div className="flex row wrap">
					{
						this.state.is_loading
						|| !this.state.product
							?
							<div className="td center aligned" data-info="nodata">
								<div className="ui active centered inline small loader"/>
							</div>
							:
							<div className="ui basic table Table_root theme1"
							     id={"sell_price_discount_table"}>
								<div className="thead">
									<div className="tr">
										<div className="th span4">เหตุการณ์</div>
										<div className="th span4">ผังบัญชี</div>
										<div className="th span8">หมายเหตุ</div>
									</div>
								</div>
								<div className="tbody Item_root">
									{
										this.state.product.product_chart_of_account
										&& this.state.product.product_chart_of_account.length > 0
										&&
										this.state.product.product_chart_of_account.map((product_chart_of_account, index) => {
											return (
												<div className="tr"
												     key={index}
												     onClick={() => {
													     // ProductBomAdjustmentCost.manage(this.state.product, product_bom_adjustment_cost);
												     }}
												     style={{cursor: 'pointer'}}
												>
													<div className="td span4">
														<div className={'flex row wrap middle-xs'}>
															{
																product_chart_of_account.event2
															}
															&nbsp;&nbsp;
															{
																product_chart_of_account.is_vat === 1
																	? <span className={'ui label green mini'}>VAT</span>
																	: null
															}
															&nbsp;&nbsp;
															{
																product_chart_of_account.is_vat === 2
																	? <span className={'ui label brown mini'}>VAT & NO VAT</span>
																	: null
															}
														</div>
													</div>
													<div
														className="td span4">
														<div>
															<b>{product_chart_of_account.code}</b> : {product_chart_of_account.title}
														</div>
													</div>
													<div className="td span8">
														<div className={'flex row wrap between-xs'}>
															<div>{product_chart_of_account.remark}</div>
															<div>
																<span className="ui label edit"
																      style={{display: 'inline-flex'}}
																      onClick={() => {
																	      window.Global.reactToDom(
																		      window.$('body'),
																		      <ProductChartOfAccountManage
																			      mode={'edit'}
																			      product={this.state.product}
																			      product_chart_of_account={product_chart_of_account}
																			      onEditedSuccess={() => {

																			      }}
																		      />
																	      );
																      }}
																>
																	แก้ไข
																</span>
															</div>
														</div>
													</div>
												</div>
											);
										})
									}
									{
										this.state.product.product_chart_of_account
										&& this.state.product.product_chart_of_account.length === 0
										&&
										<div className="tr">
											<div className="th span16">
												<div className={"row center-xs"}>
													ไม่พบรายการ
												</div>
											</div>
										</div>
									}
								</div>
							</div>
					}
				</div>
			</div>
		)
	}

	render() {
		if (!this.state.mode) {
			return null
		}

		if (this.state.mode === 'list') {
			return this.renderList()
		}

		return null;
	}
}

export class ProductChartOfAccountManage extends React.Component {
	render() {
		return (
			<div>
				<Modal className="ui modal small"
				       onShowToSetupForm={($modal) => {
					       let template = '<div class="item">\n    <b>{{code}}</b> : {{name}}\n</div>';
					       $modal.find('input[name="account_chart_of_account_id"]').explorer({
						       url: process.env.REACT_APP_DOMAIN + '/api/v1/openapi/chart_of_account',
						       additionalData: () => {
							       return {
								       limit: 30,
								       exclude_id: $modal.find('input[name="account_chart_of_account_id"]').explorer('get value')
							       }
						       },
						       key: 'chart_of_account',
						       template: {
							       list: function (value) {
								       return window.Handlebars.compile(template)(value);
							       },
							       selected: {
								       display_template: template,
								       value: 'id',
								       placeholder: 'ผังบัญชี'
							       }
						       }
					       })

					       if (this.props.mode === 'create') {
						       $modal.find('form').form2('setup', {
								       'event_onChange': (event) => {
									       if (
										       event === 'salary_income'
										       || event === 'salary_deduction'
									       ) {
										       $modal.find('select[name="is_vat"]').dropdown('set selected', '0')
									       }
								       }
							       }
						       )
						       $modal.find('form').form2('submit', {
							       method: 'POST',
							       url: process.env.REACT_APP_DOMAIN + '/api/v1/product_chart_of_account',
							       beforeSent: (object) => {
								       if (this.props.product) {
									       object.product_id = this.props.product.id;
									       object.request_data_product = 1;
								       }
								       if (this.props.relationship) {
									       object.relationship_id = this.props.relationship.id;
									       object.request_data_relationship = 1;
								       }
								       return object;
							       },
							       loadingButton: $modal.find('.button.approve'),
							       onSuccess: (response) => {
								       $modal.modal('hide');
								       window.Global.messageTop({
									       type: 'positive',
									       message: 'บันทึกข้อมูลเรียบร้อย'
								       });
								       if (this.props.onCreated) {
									       this.props.onCreated(response);
								       } else {
									       window.location.reload();
								       }
								       // window.router.navigate('/product-display/' + response['product_display']['id'], true);
							       }
						       });
					       }
					       if (this.props.mode === 'edit') {
						       $modal.find('form').form2('setup');
						       $modal.find('form').form2('submit', {
							       method: 'PUT',
							       url: process.env.REACT_APP_DOMAIN + '/api/v1/product_chart_of_account',
							       beforeSent: (object) => {
								       if (this.props.product_chart_of_account.product_id) {
									       object.product_id = this.props.product_chart_of_account.product_id;
									       object.request_data_product = 1;
								       }
								       if (this.props.product_chart_of_account.relationship_id) {
									       object.relationship_id = this.props.product_chart_of_account.relationship_id;
									       object.request_data_relationship = 1;
								       }

								       object.product_chart_of_account_id = this.props.product_chart_of_account.id;
								       return object;
							       },
							       loadingButton: $modal.find('.button.approve'),
							       onSuccess: (response) => {
								       $modal.modal('hide');
								       window.Global.messageTop({
									       type: 'positive',
									       message: 'บันทึกข้อมูลเรียบร้อย'
								       });

								       if (this.props.onEdited) {
									       this.props.onEdited(response);
								       } else {
									       window.location.reload();
								       }
							       }
						       });

						       if (this.props.product_chart_of_account.data.account_chart_of_account) {
							       $modal.find('input[name="account_chart_of_account_id"]')
								       .explorer('set value', this.props.product_chart_of_account.data.account_chart_of_account);
						       }
					       }
				       }}>
					<div className="header">
						<h2>การบันทึกบัญชี</h2>
					</div>
					<div className="content">
						<form className="ui form" autoComplete="off">
							<input type="hidden"
							       name={'product_chart_of_account_id'}
							       value={this.props.product_chart_of_account.id}
							/>
							<div className="two fields">
								<div className="field"
								     style={{
									     display: this.props.product_chart_of_account.event === 'relationship_for_overdue'
										     ? 'none'
										     : ''
								     }}
								>
									<label>เหตุการณ์</label>
									<select name="event"
									        data-form2_setup="true"
									        defaultValue={this.props.product_chart_of_account.event}
									        className={'ui dropdown'}>
										<option value="purchase_order">ซื้อ</option>
										<option value="sale_order">ขาย</option>
										<option value="buy_overdue">ค้างจ่าย</option>
										<option value="salary_income">เงินเดือน&nbsp;&nbsp;(เงินได้)</option>
										<option value="salary_deduction">เงินเดือน&nbsp;&nbsp;(เงินหัก)</option>
									</select>
								</div>
								<div className="field"
								     style={{
									     display: this.props.product_chart_of_account.event === 'relationship_for_overdue'
										     ? 'none'
										     : ''
								     }}>
									{/*<label>ภาษีมูลค่าเพิ่ม</label>*/}
									{/*<div className="ui toggle checkbox"*/}
									{/*     data-form2_setup="">*/}
									{/*	<input type="checkbox"*/}
									{/*	       name="is_vat"*/}
									{/*	       tabIndex="0"*/}
									{/*	       defaultChecked={this.props.product_chart_of_account.is_vat === 1}*/}
									{/*	       className="hidden"*/}
									{/*	/>*/}
									{/*	<label>&nbsp;</label>*/}
									{/*</div>*/}
									<label>ประเภท</label>
									<select name="is_vat"
									        data-form2_setup="true"
									        defaultValue={this.props.product_chart_of_account.is_vat + ""}
									        className={'ui dropdown'}>
										<option value="2">ภาษีมูลค่าเพิ่ม และไม่มีภาษีมูลค่าเพิ่ม</option>
										<option value="1">ภาษีมูลค่าเพิ่ม</option>
										<option value="0">ไม่มีภาษีมูลค่าเพิ่ม</option>
									</select>
								</div>
							</div>
							<div className="two fields">
								<div className="field required">
									<label>ผังบัญชี</label>
									<input type="text"
									       name="account_chart_of_account_id"
									/>
								</div>
							</div>
							<div className="field">
								<label>หมายเหตุ</label>
								<textarea name="remark" id="" cols="30" rows="10"
								          defaultValue={this.props.product_chart_of_account.remark}></textarea>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							{
								this.props.mode === 'edit'
									? <div className="ui red button"
									       onClick={() => {
										       window.Global.confirm({
											       title: 'ยืนยันลบข้อมูล',
											       content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>',
											       cancel_text: 'ไม่ดำเนินการ',
											       approve_text: 'ลบข้อมูล',
											       onShowToSetupForm: ($modal) => {
												       $modal.find('form').form2('setup');
												       $modal.find('form').form2('submit', {
													       method: 'DELETE',
													       url: process.env.REACT_APP_DOMAIN + '/api/v1/product_chart_of_account',
													       loadingButton: $modal.find('.button.approve'),
													       beforeSent: (data) => {
														       data.request_data_product = 1;
														       data.request_data_relationship = 1;
														       data.product_chart_of_account_id = this.props.product_chart_of_account.id;
														       return data;
													       },
													       onSuccess: (response) => {
														       $modal.modal('hide');
														       window.Global.messageTop({
															       type: 'positive',
															       message: 'ลบข้อมูลสำเร็จ'
														       });

														       if (this.props.onDeleted) {
															       this.props.onDeleted(response);
														       } else {
															       window.location.reload();
														       }
														       //this.props.onEditedSuccess(response);
														       // this.setState({
														       //    product_display: {...response.product_display}
														       // });
													       }
												       });
											       }
										       });
									       }
									       }>ลบข้อมูล</div>
									: null
							}
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">บันทึกข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}
